











import {
  KitDinamico,
  KitsDinamicosService,
} from "@/services/kits-dinamicos.service";
import { Component, Vue } from "vue-property-decorator";
import KitDinamicoForm from "./KitDinamicoForm.vue";
import ItemsKitDinamico from "./ItemsKitDinamico.vue";
import Loading from "@/shared/components/loading.vue";

@Component({
  components: { KitDinamicoForm, ItemsKitDinamico, Loading },
  filters: {},
})
export default class AlterarKitDinamico extends Vue {
  loading = false;
  kitDinamico: KitDinamico | null = null;

  formSaved() {
    this.$router.replace("");
  }

  get id() {
    return this.$route.params.id;
  }

  created() {
    this.fetch();
  }

  async fetch() {
    this.loading = true;
    try {
      this.kitDinamico = await KitsDinamicosService.obterKitDinamico(this.id);
    } finally {
      this.loading = false;
    }
  }
}
